'use client';

import { Box, Grid, Markdown, Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';
import { useContext } from 'react';

import { ProductTradeInContext } from '../Context';
import Summary from './Summary';

const Instructions = () => {
  const { t } = useTranslation('webshop.productTradeIn');
  const { settings } = useContext(ProductTradeInContext);

  return (
    <Grid gap={{ xs: 0, md: 600 }} templateColumns={{ xs: '1fr', md: 'repeat(2, 1fr)' }}>
      <Box sx={{ overflowY: 'auto' }}>
        <Typography variant='h3' mt={600}>
          {t('howDoesItWorkTitle')}
        </Typography>

        <Typography variant='body' mt={200}>
          {settings?.genericText}
        </Typography>

        {settings?.storeInstructions.instructions && (
          <>
            <Typography variant='h3' mt={600}>
              {t('tradingInInTheStoreTitle')}
            </Typography>

            <Markdown mt={200}>{settings?.storeInstructions.instructions}</Markdown>
          </>
        )}
      </Box>
      <Summary />
    </Grid>
  );
};

export default Instructions;
